import React, { useContext, useEffect, useState } from "react";
import { Modal, Select, Row, Col, Radio, Form, Input } from "antd";
import { useQuery } from "react-query";
import stateDistrictMapping from "../../assets/data/Indian_district_State.json";
import "../../styles/common.css";
import ConstituencyContext from "../../context/constituencyContext";
import { ToastContainer, toast } from "react-toastify";
import useAxiosInstance from "../../lib/useAxiosInstance";
import statePCMapping from "../../assets/data/state_pc_mapping.json";


const { OptGroup, Option } = Select;

const DeleteConstituency = ({ isOpen, setShowDelete }) => {
  const [form] = Form.useForm();
  const axiosInstance = useAxiosInstance();
  const constituencyContext = useContext(ConstituencyContext);

  const [state, setState] = useState();
  const [district, setDistrict] = useState();
  const [selectedConstituency, setSelectedConstituency] = useState();
  const [inputValues, setInputValues] = useState({
    state: null,
    district: null,
    constituency: null
  });
  const [constituencyType, setConstituencyType] = useState("assembly");

  const stateOptions = Object.keys(stateDistrictMapping).map((state) => ({
    value: state,
    label: state
  }));

  const districtOptions = inputValues.state
    ? stateDistrictMapping[inputValues.state].map((district) => ({
        value: district,
        label: district
      }))
    : [];

//   const fetchConstituencyByState = async (state, district) => {
//     if (!state || !district) return { data: [] };
//     return axiosInstance.get(
//       `api/constituency//getAllConstituency?state=${state}&district=${district}`
//     );
//   };
const fetchConstituencyByType = async () => {
  if (constituencyType === "parliamentary") {
    if (!inputValues.state || !inputValues.pcName) return { data: [] };
    return axiosInstance.get(`/api/parliment/getParliamentByStateAndName?state=${inputValues.state}&name=${inputValues.pcName}`);
  } else {
    if (!inputValues.state || !inputValues.district) return { data: [] };
    return axiosInstance.get(`api/constituency/getAllConstituency?state=${inputValues.state}&district=${inputValues.district}`);
  }
};

//   const constituencyByState = useQuery(
//     ["client-delete-constituency", district, state],
//     () => fetchConstituencyByState(inputValues.state, inputValues.district),
//     {
//       refetchOnWindowFocus: false
//     }
//   );
const constituencyByState = useQuery(
  ["client-delete-constituency", inputValues, constituencyType],
  fetchConstituencyByType,
  {
    enabled: !!inputValues.state,
    refetchOnWindowFocus: false
  }
);

useEffect(() => {
  if (constituencyType === "parliamentary") {
    const data = constituencyByState?.data?.data?.data?.[0];
    if (data) {
      setSelectedConstituency(data);
    }
  }
}, [constituencyByState?.data, constituencyType]);

  const handleChange = (value, name) => {
  setInputValues((prev) => ({ ...prev, [name]: value }));

  if (name === "state") {
    setState(value);
  }

  if (name === "district") {
    setDistrict(value);
  }

  if (name === "constituency") {
    const selected = constituencyByState?.data?.data?.data?.find(
      (c) => c.name === value
    );
    setSelectedConstituency(selected);
  }
};


  const closeModal = () => {
    setShowDelete(false);
    setInputValues({
      state: null,
      district: null,
      constituency: null
    });
    setSelectedConstituency(null);
    form.resetFields();
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(
        `/api/constituency/deleteConstituency/${selectedConstituency?._id}`
      );
      toast.success("Constituency deleted successfully");
      closeModal();
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete constituency");
    }
  };

  return (
    <>
      {isOpen && (
        <Modal
          className='add-user-modal'
          open={isOpen}
          onCancel={closeModal}
          width={1040}
          maskClosable={false}
          style={{ backgroundColor: "white" }}
          footer={[
            <button
              key='delete-constituency'
              form='delete-constituency-form'
              type='submit'
              className='add-user-btn'
              style={{ width: "auto", backgroundColor: "#ff4d4f", borderColor: "#ff4d4f" }}
            >
              Delete Constituency
            </button>
          ]}
        >
          <ToastContainer />
          <Form
            form={form}
            id='delete-constituency-form'
            onFinish={handleDelete}
            className='modal-body-container'
          >
            <div className='user-info-modal'>
              <div className='add-user-modal-header modal-title'>
                <h3>Delete Constituency</h3>
              </div>
            </div>
            <div className='add-user-modal-body modal-wrapper-body constituency-form'>
              <div className='model-wrapper'>
                <h4>Select Constituency</h4>
                <Radio.Group
                    className='radio mb-4'
                    value={constituencyType}
                    onChange={(e) => {
                        setConstituencyType(e.target.value);
                        setInputValues({
                        state: null,
                        district: null,
                        constituency: null
                        });
                        form.resetFields();
                    }}
                    >
                    <Radio value="assembly">Assembly</Radio>
                    <Radio value="parliamentary">Parliamentary</Radio>
                    </Radio.Group>
                <Row className='add-modal-row mt-5 mb-2'>
                  <Col span={8}>
                    <label>
                      Select State<span className='required-field'>*</span>
                    </label>
                    <Form.Item
                      name='state'
                      rules={[{ required: true, message: "Please select state" }]}
                    >
                      <Select
                        showSearch
                        onChange={(value) => handleChange(value, "state")}
                        options={stateOptions}
                        optionFilterProp='label'
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col>

                  {/* <Col span={8} offset={2}>
                    <label>
                      Select District<span className='required-field'>*</span>
                    </label>
                    <Form.Item
                      name='district'
                      rules={[{ required: true, message: "Please select district" }]}
                    >
                      <Select
                        showSearch
                        onChange={(value) => handleChange(value, "district")}
                        options={districtOptions}
                        disabled={!inputValues.state}
                        optionFilterProp='label'
                        filterOption={(input, option) =>
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </Col> */}
                    {constituencyType === "assembly" ? (
  <Col span={8} offset={2}>
    <label>Select District</label>
    <Form.Item
      name='district'
      rules={[{ required: true, message: "Please select district" }]}
    >
      <Select
        showSearch
        onChange={(value) => handleChange(value, "district")}
        options={districtOptions}
        disabled={!inputValues.state}
        optionFilterProp='label'
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    </Form.Item>
  </Col>
) : (
  <Col span={8} offset={2}>
    <label>Select Parliamentary</label>
    <Form.Item
      name='pcName'
      rules={[{ required: true, message: "Please select parliamentary name" }]}
    >
      <Select
        showSearch
        onChange={(value) => handleChange(value, "pcName")}
        disabled={!inputValues.state}
        options={(statePCMapping[inputValues.state] || []).map(pc => ({
          value: pc,
          label: pc
        }))}
        optionFilterProp='label'
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    </Form.Item>
  </Col>
)}

                </Row>

                {constituencyType==='assembly' && <Row className='add-modal-row mb-2'>
                  <Col span={8}>
                    <label>
                      Constituency<span className='required-field'>*</span>
                    </label>
                    <Form.Item
                      name='constituency'
                      rules={[{ required: true, message: "Select constituency to delete" }]}
                    >
                      <Select
                        showSearch
                        onChange={(value) => handleChange(value, "constituency")}
                        disabled={
                          !inputValues.state ||
                          !inputValues.district ||
                          !constituencyByState?.data?.data?.data?.length
                        }
                        optionFilterProp='value'
                        filterOption={(input, option) =>
                          option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                      >
                        <OptGroup>
                          {constituencyByState?.data?.data?.data
                            ?.filter((c) => c.name)
                            ?.sort((a, b) => a.name.localeCompare(b.name))
                            ?.map((constituency) => (
                              <Option key={constituency._id} value={constituency.name}>
                                {constituency.name}
                              </Option>
                            ))}
                        </OptGroup>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>}

                {selectedConstituency && (
                  <Row className='add-modal-row mb-2'>
                    <Col span={16}>
                      <p className='delete-warning'>
                        Are you sure you want to delete{" "}
                        <strong>{selectedConstituency?.name}</strong> from{" "}
                        {inputValues?.district}, {inputValues?.state}?
                      </p>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default DeleteConstituency;
